<template>
  <component :is="componentEntity" v-if="isComponentNameExist" :category="category" :pageNum="pageNum" />
  <div v-else>
    <p style="color:red">Error: 模板不存在,后台配置的vueTemplateName: {{ category!.vueTemplateName! }} 名称在前端不存在！</p>
  </div>
</template>


<script setup lang="ts" >
  import { ref, shallowRef, computed } from 'vue'
  import type { Category } from '~/types'
  import cmsUtils from '~/utils/cmsUtils'

  const componentEntity = shallowRef()
  const isComponentNameExist = ref(true)

  // 获取 category 数据
  const cmsInfo = await cmsUtils.getCmsInfo();
  const route = useRoute()
  let url = ''
  let fullUrl= ''

  // 这里处理两种情况：
  // 1. localhost/box.html (第1页，不带查询参数)
  // 2. localhost/box.html?page=2 (第2页及以后，带查询参数)
  
  // 从 URL 路径中提取分类名称（移除 .html 后缀）
  url = route.path.split('/').at(-1)!.replace('.html', '')

  // 使用 computed 来响应式地获取页码
  const pageNum = computed(() => {
    const pageQuery = route.query.page
    if (pageQuery) {
      return parseInt(pageQuery as string)
    }
    return 1
  })
  
  const category = cmsUtils.getCategoryByUrl(url,cmsInfo)

  // canonical URL 使用不带查询参数的路径
  fullUrl = (cmsInfo.website.https?"https://":"http://") +  cmsInfo.website.domain + route.fullPath;
  let imageUrl = category?.imageUrl? category.imageUrl : "https://images.leaflypackaging.com/profile/upload/2025/11/24/1_20251124233036A077.webp"
  useHead({
    title: category!.title,
    meta: [
        { name: 'title', content: category!.title },
        { name: 'keywords', content: category!.keywords },
        { name: 'description', content: category!.description },
        { name: 'locale', content: 'en_US' },

        { property: 'og:title', content: category!.title },
        { property: 'og:description', content: category!.description },
        { property: 'og:url', content: fullUrl },
        { property: 'og:image', content: imageUrl },
        { property: 'og:site_name', content: cmsInfo.website.title || 'The Leafly Packaging Company' },
        { property: 'og:type', content: 'website' },
        { property: 'og:locale', content: 'en_US' },
        // Twitter Card
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: category!.title },
        { name: 'twitter:description', content: category!.description },
    ],
    link: [
        { rel: 'canonical', href: (cmsInfo.website.https?"https://":"http://") + cmsInfo.website.domain + route.path.replace(".html","") }
    ]
  })
  
  isComponentNameExist.value = cmsUtils.checkComponentNameExist(category!.vueTemplateName ? category!.vueTemplateName : 'CategoryDefault')
  if (isComponentNameExist.value) {
    if (category!.vueTemplateName) {
      componentEntity.value = resolveComponent(category!.vueTemplateName)
    } else {
      componentEntity.value = resolveComponent('CategoryDefault')
    }
  }

</script>
<style scoped lang='scss'></style>
